export default __webpack_public_path__ + "static/media/loading.b69413fe.gif";